import React, { useCallback } from 'react';
import { Button, Input, InputNumber } from 'antd';
import { FC171 } from '../../../services/d214Api';

interface DetailGridProps {
  details: Partial<FC171>[];
  isEditing: boolean;
  selectedIdx: number;
  onSelect: (idx: number) => void;
  onAdd: () => void;
  onDelete: () => void;
  onChange: (idx: number, field: keyof FC171, value: unknown) => void;
}

const DetailGrid: React.FC<DetailGridProps> = ({
  details, isEditing, selectedIdx, onSelect, onAdd, onDelete, onChange,
}) => {
  const handleChange = useCallback((idx: number, field: keyof FC171, value: unknown) => {
    onChange(idx, field, value);
  }, [onChange]);

  return (
    <div className="d214-detail-grid">
      <div className="d214-detail-buttons">
        <Button size="small" onClick={onAdd} disabled={!isEditing}>明細新增</Button>
        <Button size="small" danger onClick={onDelete} disabled={!isEditing || selectedIdx < 0}>明細刪除</Button>
      </div>
      <div className="d214-table-wrapper">
        <table className="d214-table">
          <thead>
            <tr>
              <th>項次</th>
              <th>顏色數量</th>
              <th>單位</th>
              <th>製程1計劃</th>
              <th>製程2計劃</th>
              <th>製程3計劃</th>
              <th>製程4計劃</th>
              <th>製程5計劃</th>
              <th>製程6計劃</th>
              <th>製程7計劃</th>
              <th>製程8計劃</th>
              <th>成品量</th>
              <th>入庫日期</th>
            </tr>
          </thead>
          <tbody>
            {details.map((row, idx) => (
              <tr
                key={idx}
                className={idx === selectedIdx ? 'selected' : ''}
                onClick={() => onSelect(idx)}
              >
                <td>{row.fc171_03 ?? idx + 1}</td>
                <td>
                  {isEditing ? (
                    <InputNumber
                      size="small"
                      value={row.fc171_11}
                      onChange={v => handleChange(idx, 'fc171_11', v ?? 0)}
                      style={{ width: 90 }}
                    />
                  ) : row.fc171_11}
                </td>
                <td>
                  {isEditing ? (
                    <Input size="small" value={row.fc171_112 || ''} onChange={e => handleChange(idx, 'fc171_112', e.target.value)} style={{ width: 40 }} />
                  ) : row.fc171_112}
                </td>
                <td>{row.fc171_12 ? row.fc171_12.substring(0, 10) : ''}</td>
                <td>{row.fc171_13 ? row.fc171_13.substring(0, 10) : ''}</td>
                <td>{row.fc171_14 ? row.fc171_14.substring(0, 10) : ''}</td>
                <td>{row.fc171_15 ? row.fc171_15.substring(0, 10) : ''}</td>
                <td>{row.fc171_16 ? row.fc171_16.substring(0, 10) : ''}</td>
                <td>{row.fc171_17 ? row.fc171_17.substring(0, 10) : ''}</td>
                <td>{row.fc171_18 ? row.fc171_18.substring(0, 10) : ''}</td>
                <td>{row.fc171_19 ? row.fc171_19.substring(0, 10) : ''}</td>
                <td>{row.fc171_20 ?? 0}</td>
                <td>{row.fc171_201 ? row.fc171_201.substring(0, 10) : ''}</td>
              </tr>
            ))}
            {details.length === 0 && (
              <tr><td colSpan={13} style={{ textAlign: 'center', color: '#999' }}>無資料</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DetailGrid;
